class CalculatedInfo {
    constructor(pattern, beat, playbackRate) {
        this.playbackRate = playbackRate;
        this.calculate(pattern, beat, playbackRate);
    }
    calculate(pattern, beat, playbackRate) {
        this.durationPerBar = beat.duration / (beat.info.bars * playbackRate);
        this.durationPerBeat = this.durationPerBar / beat.info.timeSignature.beatsPerBar;
        this.durationForPattern = this.durationPerBeat * pattern.beatAmount;
        this.bpm = beat.info.timeSignature.beatsPerBar * 60 / (beat.duration / beat.info.bars);
    }
}
export default CalculatedInfo;
export { CalculatedInfo, };
